import React from 'react';
import { Fade, Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const TooltipStyle = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      color: theme.palette.common.white,
      boxShadow: theme.shadows[1],
      fontSize: 13,
      maxWidth: 195,
      backgroundColor: theme.palette.grey[600],
    },
  }),
);

const Tooltips = ({ children, title, placement }) => {
  return (
    <TooltipStyle
      className=""
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 600 }}
      title={title || ''}
      placement={placement}
      arrow
      disableInteractive
    >
      {children}
    </TooltipStyle>
  );
};

export default Tooltips;
